import React, { Component } from 'react';
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";

class VideoWidgetIframe extends Component {
    state = {
      isContent: true,
      photos: [],
      photoIndex: 0,
      isOpen: false,
      loading: true,
    }
    receiveMessage = (e) => {
        if (e.data === 'noContent') {
          this.setState({
            isContent: false,
          });
      }
      };
    render() {
      const { url, iframeClassName } = this.props;
      return (
        <>
          <iframe id="widgetIframe" className={iframeClassName} style={!this.state.isContent ? {minHeight: 0,height: 65, marginBottom: 4, border: '1px solid #bdb0b0'} : {}} src={url}></iframe>
       </>
        );
    }

    componentDidMount(){
        window.addEventListener('message', this.receiveMessage )
    }
}

export default VideoWidgetIframe;
